import React, { useContext, useState, useEffect, useRef } from "react";
import { store } from "../../Store";
import { Link, useLocation } from "react-router-dom";

import { NavbarBrand } from "../components/NavbarBrand";
import { NavbarNav } from "./components/NavbarNav";
import { DropdownResponsive } from "./components/DropdownResponsive";
import { SkeletonHeader } from "./components/SkeletonHeader";

import useIsMobile from "../../../js/utilities/useIsMobile";
import { useNetworkStatus } from "../../../hooks/use-network-status";
import { useTranslations } from "../../../hooks/use-translations";
import { usePublicHeaderDropdown } from "../../../hooks/header/usePublicHeaderDropdown";
import { LangButton } from "../../language/lang-button";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Tools } from "./components/Tool";
import { useLanguage } from "../../../hooks/use-language";

/**
 * Componente del header sin login
 * @returns {JSX.Element} - PublicHeader
 */
export const PublicHeader = () => {
	const lang = useLanguage();
	const textosInterfaz = useTranslations({ section: "header", lang: lang, array: true });

	const globalState = useContext(store);
	const { dispatch, state } = globalState;

	const [isLoading, setIsLoading] = useState(true);

	const isMobile = useIsMobile();
	const internetConnection = useNetworkStatus();

	const publicHeaderDropdown = usePublicHeaderDropdown();
	const dropdownButtonRef = useRef(null);

	const location = useLocation();

	/*Asigna el botón que abre el dropdown del header publico o sin login */
	useEffect(() => {
		if (dropdownButtonRef.current) {
			globalState.dispatch({
				type: "CHANGE",
				path: "publicHeaderDropdown.triggerButtonRef",
				value: dropdownButtonRef,
			});
		}
	}, [dropdownButtonRef.current]);

	useEffect(() => {
		if (state?.datosHeader) {
			setIsLoading(false);
		}
	}, [state?.datosHeader]);

	return (
		<>
			{isLoading ? (
				<SkeletonHeader />
			) : (
				<div className="public-header">
					<nav className="h-100 d-flex justify-content-between aling-items-center mx-0">
						<div className=" px-0 d-flex">
							<NavbarBrand />
						</div>

						{!isMobile && (
							<div className="d-flex justify-content-center">
								<NavbarNav textosInterfaz={textosInterfaz} lang={lang} />
							</div>
						)}
						{!isMobile && (
							<div>
								<Tools textosInterfaz={textosInterfaz}/>
							</div>
						)}

						{isMobile && (
							<div className="col-9 px-0  d-flex justify-content-end align-items-center">
								<Link
									to="/contacto"
									className={`btn-menu btn-contact-movil mr-3 ${location.pathname === '/contacto' && 'activeMode'}`}
								>
									{textosInterfaz?.contacto || 'Contacto'}
								</Link>
								<button
									ref={dropdownButtonRef}
									onClick={() => {
										if (internetConnection.online) {
											publicHeaderDropdown.setVisible(
												!publicHeaderDropdown?.state?.visible
											);
										}
									}}
									className={`btn-menu focusable-red ${publicHeaderDropdown?.state?.visible && "activeMode"
										}`}
								>
									{textosInterfaz?.menu || "Menú"}
									<Icon icon="material-symbols:keyboard-arrow-down-rounded" className="icon-down"/>
								</button>

								<Link
									to="/login"
									className={`focusable-red icon-login ${location.pathname === '/login' ? "icon-responsive  activeMode mx-2" : "icon-responsive mx-2"}`}
								>
									<span>{textosInterfaz?.ingresar || 'Ingresar'}</span>
								</Link>

								<div className="mr-2">
									<LangButton />
								</div>
							</div>
						)}
					</nav>

					{isMobile && <DropdownResponsive textosInterfaz={textosInterfaz} />}
				</div>
			)}
		</>
	);
};
